<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <div class="font-weight-bold text-red">Notes:</div>
                            <div class="text-red">*Please select all files you wish to upload at once.</div>
                            <div class="text-red">*Also please submit files with short names.</div>
                            <!-- “This compliance require {{ this.compliance.max_upload }} pdf uploads.” -->
                        </v-col>
                        <v-col cols="12">
                            <v-file-upload
                                v-model="files"
                                rounded="lg"
                                height="310"
                                clearable
                                show-size
                                multiple
                                elevation="1"
                                scrim="darkGreen"
                                accept="application/pdf"
                                >
                            </v-file-upload>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmit" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to resubmit your compliance?</div>
                <div class="font-weight-light mt-2">Note: Once resubmitted, some details may not be updated. Please review your compliance information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmSubmit = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="resubmitCompliance()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            file_id: null,
            filesToDelete: null,
            files: null,
            compliance: null,
            compliance_data: null,

            confirmSubmit: false,

            newFormRules: {

            },
        }
     },
     methods: {
        init(data){
            this.dialog = true
            this.dialog_title = 'Resubmit Files'
            this.dialog_sub_title = data.compliance.compliance_name + " - " + data.facultyLoad.code + " - " + data.facultyLoad.title
            this.action = 'edit'

            this.file_id = data.file.id
            this.filesToDelete = data.file.filenames
            this.files = null
            this.compliance = data.compliance
            this.compliance_data = data
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){

                const form = this.$refs.form;
                if (!form) return;

                const { valid } = await form.validate();

                if(valid){

                    if (this.compliance?.is_upload && (!this.files || this.files.length != this.compliance?.max_upload)) {
                        showSnackbar('Please upload at least ' + this.compliance?.max_upload + ' file/files.')
                        return;
                    }

                    this.confirmSubmit = true
                }
                
            }
        },
        resubmitCompliance(){
            const { showSnackbar } = useSnackbar()
            this.loading = true

            let formData = new FormData()

            let form = {
                file_id: this.file_id,
                created_by: this.$store.state.user.id,
                filesToDelete: this.filesToDelete,
                compliance_data: this.compliance_data,         
            }

            if (this.files && this.files.length > 0) {
                for (let i = 0; i < this.files.length; i++) {
                    formData.append('files', this.files[i]);
                }
            }

            formData.append('data', JSON.stringify(form))

            const token = localStorage.getItem('aums-token')

            axios.patch(process.env.VUE_APP_SERVER_URL + '/compliance-upload/resubmitCompliance', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Resubmit Files successfully!')
                    this.$refs.form.reset()
                    this.confirmSubmit = false
                    this.dialog = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..', 'error')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    showSnackbar('An unexpected error occurred.', 'error')
                }
            })
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>